export default "__VITE_ASSET__ti7XOTHL__"